/**
 * Shared tensor and math helpers for AI pipelines (ONNX and others).
 * Any pipeline that reads tensor data or needs clamp can use these.
 */

/**
 * Get underlying typed array from an ONNX tensor (ORT Web may use .data or .cpuData).
 * @param {import('onnxruntime-web').Tensor} tensor
 * @returns {Float32Array|Int32Array|BigInt64Array|undefined}
 */
export function getTensorData(tensor) {
  return tensor?.data ?? tensor?.cpuData;
}

/**
 * Clamp a value to [min, max].
 * @param {number} value
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */
export function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}
